/*
 * Elektronische Widerrufsfunktion (§ 356a BGB) – Ablauf auf der Seite „Vertrag widerrufen“.
 * Schritt 1: Angaben, „Weiter zur Bestätigung“. Schritt 2: Zusammenfassung, „Widerruf bestätigen“.
 * Beim Bestätigen: optional POST an den Webhook aus den Theme-Einstellungen (verschickt die
 * Eingangsbestätigung), danach immer das native Shopify-Kontaktformular. Ein Fehler beim Webhook
 * hält den Widerruf nie auf.
 */
(function () {
  var root = document.querySelector('[data-kk-withdrawal]');
  if (!root) return;
  var STORE_KEY = 'kk-withdrawal-receipt';

  function store(fn) { try { return fn(window.sessionStorage); } catch (e) { return null; } }

  /* ---------- Erfolgsseite nach dem Absenden ---------- */
  var success = root.querySelector('[data-kk-wd-success]');
  if (success) {
    var saved = store(function (s) { return JSON.parse(s.getItem(STORE_KEY) || 'null'); });
    if (saved && saved.rows) {
      var list = root.querySelector('[data-kk-wd-receipt-list]');
      fillList(list, saved.rows);
      root.querySelector('[data-kk-wd-receipt]').hidden = false;
      if (saved.email) root.querySelector('[data-kk-wd-success-mail]').textContent = ' an ' + saved.email;
      store(function (s) { s.removeItem(STORE_KEY); });
    }
    var printBtn = root.querySelector('[data-kk-wd-print]');
    if (printBtn) printBtn.addEventListener('click', function () { window.print(); });
    success.focus();
    return;
  }

  var form = root.querySelector('form');
  if (!form) return;
  root.classList.add('is-js');

  var step1 = root.querySelector('[data-kk-wd-step="1"]');
  var step2 = root.querySelector('[data-kk-wd-step="2"]');
  var nextBtn = root.querySelector('[data-kk-wd-next]');
  var backBtn = root.querySelector('[data-kk-wd-back]');
  var confirmBtn = root.querySelector('[data-kk-wd-confirm]');
  var summary = root.querySelector('[data-kk-wd-summary]');
  var summaryList = root.querySelector('[data-kk-wd-summary-list]');
  var statusEl = root.querySelector('[data-kk-wd-status]');
  var itemsWrap = root.querySelector('[data-kk-wd-items]');
  var items = form.querySelector('#KkWdItems');

  nextBtn.hidden = false;
  backBtn.hidden = false;
  summary.hidden = false;

  /* Bestellnummer aus dem Link in der Bestellbestätigung vorbelegen (?bestellung=1234) */
  var params = new URLSearchParams(window.location.search);
  var preOrder = params.get('bestellung') || params.get('order');
  var orderInput = form.querySelector('[data-kk-wd-order]');
  if (preOrder && !orderInput.value) orderInput.value = preOrder.replace(/[^\w#\-]/g, '').slice(0, 30);

  function scopeValue() {
    var c = form.querySelector('[data-kk-wd-scope]:checked');
    return c ? c.value : '';
  }
  function syncScope() {
    var partial = scopeValue() === 'Nur einzelne Artikel';
    itemsWrap.hidden = !partial;
    items.required = partial;
  }
  Array.prototype.forEach.call(form.querySelectorAll('[data-kk-wd-scope]'), function (r) {
    r.addEventListener('change', syncScope);
  });
  syncScope();

  function val(sel) { var el = form.querySelector(sel); return el ? el.value.trim() : ''; }
  function formatDate(iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
    return m ? m[3] + '.' + m[2] + '.' + m[1] : iso;
  }
  function data() {
    var d = {
      name: val('#KkWdName'),
      order: val('#KkWdOrder'),
      order_date: formatDate(val('#KkWdDate')),
      scope: scopeValue(),
      items: scopeValue() === 'Nur einzelne Artikel' ? val('#KkWdItems') : '',
      email: val('#KkWdEmail')
    };
    d.declaration = 'Hiermit widerrufe ich, ' + d.name + ', den von mir abgeschlossenen Vertrag ' +
      (d.items ? 'über folgende Artikel der Bestellung ' + d.order + ': ' + d.items : 'über die Bestellung ' + d.order + ' (gesamte Bestellung)') +
      (d.order_date ? ', bestellt am ' + d.order_date : '') + '.';
    return d;
  }
  function rows(d) {
    var r = [
      ['Erklärung', d.declaration],
      ['Name', d.name],
      ['Bestellnummer', d.order]
    ];
    if (d.order_date) r.push(['Bestelldatum', d.order_date]);
    r.push(['Umfang', d.scope]);
    if (d.items) r.push(['Artikel', d.items]);
    r.push(['E-Mail für die Bestätigung', d.email]);
    return r;
  }
  function fillList(list, r) {
    list.textContent = '';
    r.forEach(function (row) {
      var dt = document.createElement('dt'); dt.textContent = row[0];
      var dd = document.createElement('dd'); dd.textContent = row[1];
      list.appendChild(dt); list.appendChild(dd);
    });
  }
  function step1Valid() {
    var fields = step1.querySelectorAll('input, textarea');
    for (var i = 0; i < fields.length; i++) {
      if (!fields[i].checkValidity()) { fields[i].reportValidity(); return false; }
    }
    return true;
  }

  nextBtn.addEventListener('click', function () {
    if (!step1Valid()) return;
    fillList(summaryList, rows(data()));
    step1.classList.add('is-done');
    step2.classList.add('is-active');
    var h = step2.querySelector('h2');
    h.setAttribute('tabindex', '-1'); h.focus();
    window.scrollTo({ top: root.offsetTop, behavior: 'smooth' });
  });
  backBtn.addEventListener('click', function () {
    step2.classList.remove('is-active');
    step1.classList.remove('is-done');
    form.querySelector('#KkWdName').focus();
  });

  var sending = false;
  form.addEventListener('submit', function (ev) {
    if (form.dataset.kkWdReady === '1') return; /* zweiter, nativer Durchlauf */
    ev.preventDefault();
    if (sending) return;
    if (!step2.classList.contains('is-active')) { nextBtn.click(); return; }
    sending = true;
    confirmBtn.disabled = true;
    statusEl.textContent = 'Ihr Widerruf wird übermittelt …';

    var d = data();
    var now = new Date();
    form.querySelector('[data-kk-wd-clienttime]').value = now.toLocaleString('de-DE', { timeZone: 'Europe/Berlin' }) + ' (' + now.toISOString() + ')';
    form.querySelector('[data-kk-wd-body]').value = d.declaration;
    store(function (s) { s.setItem(STORE_KEY, JSON.stringify({ rows: rows(d), email: d.email })); });

    var done = function () {
      form.dataset.kkWdReady = '1';
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    };
    var endpoint = (root.getAttribute('data-endpoint') || '').trim();
    if (!/^https:\/\//i.test(endpoint)) { done(); return; }

    var payload = {
      type: 'widerruf',
      shop: window.location.hostname,
      page: window.location.href.split('?')[0],
      client_time: now.toISOString(),
      name: d.name,
      email: d.email,
      order: d.order,
      order_date: d.order_date,
      scope: d.scope,
      items: d.items,
      declaration: d.declaration
    };
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 8000);
    fetch(endpoint, {
      method: 'POST',
      body: new URLSearchParams(payload), /* Formular-Kodierung: einfache Anfrage ohne CORS-Preflight, n8n liest die Felder direkt */
      signal: ctrl ? ctrl.signal : undefined,
      keepalive: true
    }).catch(function () { /* Bestätigung kommt dann manuell, Widerruf geht trotzdem raus */ })
      .then(function () { clearTimeout(timer); done(); });
  });
})();
